//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global __ENV_NAME__ */
/* global __APP_VERSION__ */
import _ from 'lodash';
import Vue from 'vue';
import ShareDialog from './share-dialog.vue'
import TimeBoardSettings from './time-board-settings.vue'
import FilteringDialog from './filtering-dialog.vue'
import simpleSnackbar from './simple-snackbar.vue'
import SidebarMenu from './sidebar-menu.vue';
import {getCsrfToken} from "../session.js";
import {
  downloadAsJson,
  calcVisibility,
} from '../utils.js';
import {
  countComponentsRecursively,
  measureTime,
  avgPerfMeasurements,
} from '../perf-utils.js';
import DateDialog from './date-dialog.vue';
import {
  createReactiveCache,
  defaultListID,
  initializeCache,
  populateCache,
} from '../reactive-cache.js';
import {Item} from '../item.js';
import {
  populateCurrent,
  clearTestData,
} from '../data-utils.js'
import {
  initGoogleApi,
  googleSignIn,
  googleSignOut,
  loadEvents,
} from '../gcalendar-utils.js'

// The delay of dragEnd2 after dragEnd.
const kDragEnd2DelayMs = 500;

async function postToEndpoint(endpoint) {
  return Vue.http.post(endpoint, {}, {
    headers: {'X-CSRFToken': getCsrfToken(),},
    timeout: 3000, // 3 seconds.
  });
}

export default {
  data() {
    return {
      signedInToGoogle: false,
      googleCalendars: {},
      showSidebar: false,
      activeTimeCols: [],
      showDone: this.readDoneSetting(),
      showArchived: this.readSetting('show-archived', false),
      showNotMine: this.readSetting('show-not-mine', true),
      showOnlyCurrent: this.readSetting('show-only-current', false),
      selectedLabels: [],
      swInfo: window.swInfo,
      appVersion: __APP_VERSION__.trim(),
      branchName: __BRANCH_NAME__.trim(),
      appName: __ENV_NAME__ === 'prod'
        ? 'Organizer'
        : 'Organizer (' + __ENV_NAME__ + ')',
      networkOnLine: window.navigator.onLine,
      // pendingDrag is true when there is a card picked up for dragging,
      // or it's already dragged. Precisely, it is true between Sortable's
      // onChoose and onUnchoose events/callbacks.
      pendingDrag: false,
      // pendingishDrag is like pendingDrag, but with a delayed end. This is
      // to account for the delays in finishing the drag and saving the
      // change - when pendingishDrag is false, we can assume that things are
      // more or less settled down.
      pendingishDrag: false,
      debouncedDragEnd2: _.debounce(() => {
        this.dragEnd2();
      }, kDragEnd2DelayMs),
      firstRun: true,
      lastDashboard: this.readSetting('last-dashboard', '/calendar'),
      privateMode: this.readSetting('private-mode', false),
    };
  },
  components: {
    DateDialog,
    ShareDialog,
    TimeBoardSettings,
    FilteringDialog,
    simpleSnackbar,
    SidebarMenu,
  },
  async mounted() {
    if (this.$settings?.gcalendar) initGoogleApi(this);
    window.addEventListener('online', this.onOnline);
    window.addEventListener('offline', this.onOffline);
    this.$router.beforeEach(this.onRouteUpdate);
  },
  beforeDestroy() {
    window.removeEventListener('online', this.onOnline);
    window.removeEventListener('offline', this.onOffline);
  },
  computed: {
    // Apart from separating "time" lists from "normal" ones, filtering below
    // is needed for triggering reactivity when lists are added/deleted.
    subtaskOfLists() {
      return this.getSortedLists("subtaskOf")
    },
    allSubtaskOfLists() {
      return [...this.subtaskOfLists, this.$reactiveCache.docs[defaultListID(this.$defaultDB)]]
    },
    plannedForLists() {
      return this.getSortedLists("plannedFor")
    },
    categoryLists() {
      return this.getSortedLists("category")
    },
    statusLists() {
      return this.getSortedLists("status")
    },
    reactiveLabels() {
      // This filtering doesn't actually do much, but without it reactivity
      // isn't triggered corectly when labels are added/deleted.
      return Object.keys(this.$reactiveCache.labels)
        .map(id => this.$reactiveCache.docs[id]);
    },
    reactiveLayouts() {
      // This filtering doesn't actually do much, but without it reactivity
      // isn't triggered corectly when labels are added/deleted.
      return Object.keys(this.$reactiveCache.layouts)
        .map(id => this.$reactiveCache.docs[id])
        .filter(item => calcVisibility(item, this));
    },
    debug() {
      // read from settings if available, with default depending on environment
      let debug = false;
      if (this.$sessionState &&
          this.$settings &&
          this.$settings.debug !== undefined) {
        debug = this.$settings.debug;
      } else if (__ENV_NAME__ === 'dev') {
        debug = true;
      }
      console.debug("debug is", debug ? "ON" : "OFF")
      return debug;
    },
    markdownEnabled() {
      return this.$sessionState
          && this.$settings
          && this.$settings.markdown === true
    },
    hasSharing() {
      if (this.$sessionState) {
        return Object.keys(this.$sessionState.dbs).length > 1
      } else {
        return false;
      }
    }
  },
  methods: {
    getSortedLists(relation) {
      let allLists = Object.keys(this.$reactiveCache.lists)
        .map(id => this.$reactiveCache.docs[id])
        .filter(list => list.relation === relation)
        .filter(list => list._id !== defaultListID(this.$defaultDB))

      let orderDoc = this.$reactiveCache.docs['layout:all-'+relation];
      if (!orderDoc) {
        if (allLists.length > 0) {
          let name
          let icon
          switch (relation) {
            case "subtaskOf":
              name = "All lists"
              icon = "view_list"
              break
            case "plannedFor":
              name = "All periods"
              icon = "schedule"
              break
            case "category":
              name = "All categories"
              icon = "category"
              break
            case "status":
              name = "All statuses"
              icon = "assistant_direction"
              break
          }
          orderDoc = new Item({
              _id: 'layout:all-'+relation,
              name,
              type: 'layout',
              icon,
              layout: allLists.map(list => list._id),
            },
            this.$reactiveCache,
            this.$defaultDB,
          );
          this.$reactiveCache.docs['layout:all-'+relation] = orderDoc;
          orderDoc.save();
        }

        return allLists.filter(list => calcVisibility(list, this));
      }
      // check if all lists are included.
      let change = false;
      for (const list of allLists) {
        if (!orderDoc.layout.flat().includes(list._id)) {
          orderDoc.layout.push(list._id)
          change = true;
        }
      }
      if (change) orderDoc.save();

      return orderDoc.layout
        .map(id => this.$reactiveCache.docs[id])
        .filter(list => !!list)
        .filter(list => list.relation === relation)
        .filter(list => list._id !== defaultListID(this.$defaultDB))
        .filter(list => calcVisibility(list, this));
    },
    googleSignIn,
    googleSignOut,
    loadEvents,
    // Keep track of the last viewed dashboard (for MRU).
    onRouteUpdate(to, from, next) {
      // Ignore hash changes, only consider base path changes.
      if (!from.path.startsWith('/task/') && from.path !== to.path) {
        this.lastDashboard = from.path;
      }
      // Persist across sessions.
      if (from.path.startsWith('/lists/')) {
        localStorage.setItem('last-dashboard', JSON.stringify(from.path))
      }
      next();
    },
    // Backward compatibility. Remove in the future.
    readDoneSetting() {
      const showDone = this.readSetting('show-done')
      const hideDone = this.readSetting('hide-done')
      if (showDone === null) {
        if (hideDone === null) {
          return true  // show done by default.
        }
        return !hideDone
      } else {
        return showDone
      }
    },
    readSetting(key, defaultValue=null) {
      const storageValue = localStorage.getItem(key)
      if (storageValue == null) {
        return defaultValue
      }
      try {
        return JSON.parse(storageValue)
      } catch {
        return (storageValue)
      }
    },
    openChangelog() {
      window.open(
        'https://docs.google.com/document/d/1tsAZ6hxvnqOK0Di11t1gn4bqzmT2j3CeWsaYqFO0Z00/preview',
        '_blank'
      );
    },
    reloadPage() {
      location.reload();
    },
    downloadAsJson,
    dumpReactiveCache() {
      if (!this.$sessionState || !this.$sessionState.loggedIn) {
        throw new Error('Not logged in, can\'t back up any data.');
      }
      downloadAsJson(
        this.$reactiveCache,
        `organizer-cache-dump-${this.$sessionState.loggedInAs}-${new Date().toJSON()}.json`
      );
    },
    dumpLocalDatabase() {
      if (!this.$sessionState || !this.$sessionState.loggedIn) {
        throw new Error('Not logged in, can\'t back up any data.');
      }
      downloadAsJson(
        this.$reactiveCache.docs,
        `organizer-backup-${this.$sessionState.loggedInAs}-${new Date().toJSON()}.json`
      );
    },
    // Doesn't really load anything into the database, but this is a useful
    // piece of code for reading JSON from file into the running page.
    loadDatabaseDump() {
      if (!this.$sessionState || !this.$sessionState.loggedIn) {
        throw new Error('Not logged in, nowhere to load the data to.');
      }
      function readSingleFile(e) {
        const file = e.target.files[0];
        if (!file) {
          return;
        }
        const reader = new FileReader();
        reader.onload = function(e) {
          const tasks = JSON.parse(e.target.result);
          window.loadedDatabaseDump = tasks;
          console.log('window.loadedDatabaseDump =', tasks);
        };
        reader.readAsText(file);
      }

      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.addEventListener('change', readSingleFile, false);
      fileInput.click();
    },
    saveDatabaseDump() {
      for (const item of Object.values(window.loadedDatabaseDump)) {
        delete item._rev
        main.$defaultDB.put(item)
      }
    },
    onOnline() {
      this.networkOnLine = true;
    },
    onOffline() {
      this.networkOnLine = false;
    },
    async createTeam() {
      const team_name = prompt(this.$gettext('Team name:'));
      if (team_name == null) return;  // Prompt cancelled.
      const dbName = await this.createSharedDB(team_name);

      if (dbName) {
        const emails = prompt(
          this.$gettext('Members emails (separate with spaces):'));
        if (emails != null) {
          for (const email of emails.split(' ')) {
            await this.addTeamMember(dbName, email)
          }
        }
        this.reloadPage()  // TODO: refresh list view without reload
      }
    },
    async createSharedDB(team_name) {
      let dbName = null
      try {
        await Vue.http.post('/create_shared_db/', {team_name}, {
          headers: {'X-CSRFToken': getCsrfToken()},
          emulateJSON: true,
        }).then(response => {dbName = response.body})
        console.info('Created team database ' + dbName);
        alert(this.$gettext('Team created!'));
      } catch (response) {
        console.error(response);
        const errText = `${response.statusText}: ${response.body}`;
        console.error(errText);
        alert(errText);
      }
      return dbName
    },
    async addTeamMember(db_name, email) {
      try {
        await Vue.http.post('/add_team_member/', {db_name, email}, {
          headers: {'X-CSRFToken': getCsrfToken()},
          emulateJSON: true,
        });
        const successText = email + this.$gettext(
          ' added.\nNote: (s)he must reload the application to see changes.');
        console.info(successText);
        alert(successText);
      } catch (response) {
        console.error(response);
        const errText = `${response.statusText}: ${response.body}`;
        console.error(errText);
        alert(errText);
      }
    },
    dragStart() {
      this.pendingDrag = true;
      this.pendingishDrag = true;
    },
    dragEnd() {
      this.pendingDrag = false;
      this.debouncedDragEnd2();
    },
    // To be called with some delay (and debounce) after dragEnd().
    dragEnd2() {
      this.pendingishDrag = false;
    },
    // only for debugging and profiling from console.
    countComponents() {
      return countComponentsRecursively(this)
    },
    async time(callback, ...args) {
      return await measureTime(callback, ...args);
    },
    async debugCreatingCache() {
      const dbs = Object.values(this.$sessionState.dbs)
      const cache = await measureTime(createReactiveCache, dbs)
      console.group("Creating cache details:")
      avgPerfMeasurements('createReactiveCache')
      avgPerfMeasurements('5.1. initializing cache')
      for (const db of dbs) {
        avgPerfMeasurements('5.2. loading from pouch ' + db.name)
        avgPerfMeasurements('5.3. processing data from ' + db.name)
      }
      console.groupEnd()
      return cache
    },
    async initNewCache() {
      const dbs = Object.values(this.$sessionState.dbs)
      return await measureTime(initializeCache, dbs)
    },
    async populateCache(cache, db, data) {
      await measureTime(populateCache, cache, db, data);
    },
    clearTestData() {
      clearTestData(this.$defaultDB);
    },
    populateCurrent(tasks=100, subtasks=200, useLongNames=true) {
      populateCurrent(this.$defaultDB, tasks, subtasks, useLongNames)
    },
  },
};
